export default {"src":"/accounts/_next/static/media/Camera.07a2e840.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};